module.exports = __webpack_public_path__ + "img/saveurs_simplissime.ca4e7126.jpg";